module.exports = __webpack_public_path__ + "static/media/AB_iPhoneX_Google.aba780ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_header/AB_iPhoneX_Google.png
// module id = 536
// module chunks = 0